import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import "../assests/css/studentdashboard/studentsidelyout/Studentsidelayout.css";

import StudentSidebar from "../components/studentdashboardcard/studentsidebar/StudentSidebar.js";
import { AppContext } from "../context/Appcontext.js";

const StudentsideLayout = ({ children }) => {
  const { setAuthToken,loggedInStudent, setLoggedInStudent } = useContext(AppContext);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setLoggedInStudent(JSON.parse(localStorage.getItem("student")));
    setAuthToken(authToken);
    
  }, []);
  return (
    <div className="admin-master-layout">
      <Row className="g-0">
        <Col className="sidebar-col">
          <StudentSidebar />
        </Col>
        <Col className="content-col">
          <div className="seller-content-wrapper">{children}</div>
        </Col>
      </Row>
    </div>
  );
};

export default StudentsideLayout;
